// Port of api/fuel/app/classes/insights/collection/bestduration.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'bestduration',
    insight: ['bestduration.duration', 'bestduration.count'],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        var durationType = (filter['bestduration.duration'] !== undefined) ? filter['bestduration.duration'] : 'count'
        var countType = (filter['bestduration.count'] !== undefined) ? filter['bestduration.count'] : 'best'

        var x = (vars && vars.x !== undefined) ? vars.x : 0
        var y = (vars && vars.y !== undefined) ? vars.y : 0

        if (x === false) x = 0
        if (y === false) y = 0

        var bestduration = []

        var raw = Util.queryFast('\
            SELECT \
                g.game_name AS gn, \
                g.game_id AS g, \
                g.game_players_community AS c, \
                g.game_time_max AS x, \
                g.game_time_min AS n, \
                g.game_players_max AS px, \
                g.game_players_min AS pn \
            FROM \
                collection co \
                JOIN \
                game g \
                ON \
                co.game_id = g.game_id \
            WHERE \
                co.user_id IN (' + Util.in(userIndex) + ') \
                AND \
                co.collection_own = 1 \
                AND \
                g.game_time_max > 0 \
                AND \
                g.game_players_min > 0 \
                AND \
                co.collection_expansion = 0 \
            GROUP BY \
                g.game_id \
            ORDER BY \
                g.game_sortname ASC, \
                g.game_weight_avg ASC \
        ')

        for (var ri = 0; ri < raw.length; ri++) {
            var item = raw[ri]
            var bests = []

            var pc = null
            try { pc = JSON.parse(item.c) } catch (e) { pc = null }
            if (!pc) pc = {}

            for (var i = 1; i <= 6; i++) {

                if (countType === 'official') {

                    if (i >= item.pn && i <= item.px) {
                        bests.push(i)
                    }

                } else if (pc[i] !== undefined) {

                    if (countType === 'best' && pc[i].b > pc[i].r + pc[i].n) {
                        bests.push(i)
                    } else if (countType === 'recommended' && pc[i].b + pc[i].r > pc[i].n) {
                        bests.push(i)
                    }

                }

            }

            for (var bi = 0; bi < bests.length; bi++) {
                var best = bests[bi]
                var duration = item.x

                if (durationType === 'mid' && item.x > item.n) {
                    duration = ((item.x - item.n) / 2) + item.n
                } else if (durationType === 'count' && item.x > item.n && item.px > item.pn) {
                    duration = (item.x - item.n) / (item.px - item.pn + 1)
                    duration = item.n + (duration * (best - item.pn + 1))
                }

                bestduration.push({
                    g: parseInt(item.g, 10),
                    b: parseInt(best, 10),
                    t: parseFloat((Math.round(duration * 100) / 100).toFixed(2)),
                    n: item.n
                })
            }
        }

        if (detail) {

            var games = []

            for (var di = 0; di < bestduration.length; di++) {
                var ditem = bestduration[di]

                var itemX = Math.floor(ditem.t / 60)
                var itemY = Math.floor(ditem.b / 1) - 1

                if (itemX > 5) itemX = 5

                if ((x === false || itemX === x) && (y === false || itemY === y)) {

                    this._references.games.push(ditem.g)

                    games.push({
                        id: ditem.g,
                        time: ditem.t,
                        best: ditem.b,
                        name: ditem.n
                    })

                }
            }

            return {
                games: games
            }

        } else {

            return {
                bestduration: bestduration
            }

        }

    }
})
